<template>
    <div  v-if="projectMessages" class="project-section">
        <div class="btn-wrap delete-project">
            <a
                :href="projectMessages.deleteProjectLink"
                class="btn-std btn delete-proj"
                @click="deleteProject(projectMessages.deleteProjectLink)"
            >
                {{projectMessages.deleteProject}}
            </a>
        </div>
        <div class="title-ctrl">
            <project-name :project_id="project_id" :project_name="projectMessages.projectName"></project-name>
            <a v-if="projectMessages.productsCount > 3" :data-variant="projectMessages.hide" class="roll-up js-roll-up">{{projectMessages.show}}</a>
        </div>
        <div class="prod-cont">
            <div class="project-wrap">
                <table data-show="3" class="table js-hidden-rows">
                    <tr>
                        <th v-for="projectColumn in projectMessages.columns">{{projectColumn}}</th>
                    </tr>
                    <template v-if="getProjectItems">
                        <project-item v-for="projectItem in getProjectItems" :projectItem="projectItem" :selfSelect="selfSelect" :photoSelect="photoSelect" :columns="projectMessages.columns"
                                      :key="projectItem.id" :project_id="project_id"></project-item>
                    </template>
                    <template v-else>
                        <div>{{projectMessages.noProducts}}</div>
                    </template>
                </table>
                <a v-if="projectMessages.productsCount > 3" class="load-more js-load-more">
                    {{projectMessages.showMore}}
                </a>
                <template v-if="getProjectItems">
                    <div class="table-total" v-if="getProjectTotalSum.optSum">
                        <div class="bold" v-html="getProjectTotalSum.retailSum"></div>
                        <div v-html="getProjectTotalSum.optSum"></div>
                        <div v-html="getProjectTotalSum.retailAznSum"></div>
                        <div v-html="getProjectTotalSum.profit"></div>
                    </div>
                    <div class="table-total" v-else>
                        <div class="bold" v-html="getProjectTotalSum.retailSum"></div>
                    </div>
                </template>
                <div class="project-bottom">
                    <a></a>
                    <div class="btn-wrap">
                        <a :href="projectMessages.cancelProjectLink" class="btn-light btn">
                            {{projectMessages.cancelProject}}
                        </a>
                        <a :href="projectMessages.toProjectDetailLink" class="btn-std btn" @click="addedUserProps">
                            {{projectMessages.toProjectDetail}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import uiInputField from "vueComponents/ui-elements/fields/Input";
import ProjectItem from "vueComponents/project/ProjectItem";
import ProjectName from "vueComponents/project/ProjectName";

/**
 * Контейнер для отображения содержимого проекта.
 *
 *  - projectItems информация о товарах в проекте
 *  - projectTotalSum стоимость товаров в проекте
 *  - projectMessages статический текст для отображение в проекте выдаваемый бэком в зависемости от языка
 *   <project-item> - конкретный товар в проекте
 * @vuedoc
 * @module vue:containers/Project
 * @exports vue:containers/Project
 */
export default {
    name: "project-section",

    props: ['project_id'],

    components: {
        'project-item': ProjectItem,
        'ui-input-field': uiInputField,
        'project-name': ProjectName,
    },

    data() {
        return {
            selfSelect: true,
            photoSelect: false,
            link: '',
        }
    },

    computed: {

        ...mapGetters('project', [
            'projectItems', 'projectTotalSum', 'projectMessages',
        ]),

        /**
         *  Вычисляемое свойство возвращает товары в проекте
         *
         * @method getProjectItems
         */
        getProjectItems: function () {
            if (this.projectItems) {
                return this.projectItems;
            }
            return false;
        },

        /**
         *  Вычисляемое свойство возвражает общую стоимость товаров в проекте
         *
         * @method getProjectTotalSum
         */
        getProjectTotalSum: function () {
            if (this.projectTotalSum) {
                return this.projectTotalSum;
            }
            return false;
        },
    },
    mounted() {
        if (this.project_id)
            this.$store.dispatch('project/getItems', {
                projectId: this.project_id,
                selfSelect: this.selfSelect,
                photoSelect: this.photoSelect
            });
        else
            console.log("no project name");

        this.firstTime = 'Y';

    },
    methods: {
        deleteProject(link) {
            event.preventDefault();
            this.link = link;
            this.$modal.show({
                    template: `
                        <def-modal-alert >
                        <div class="modal-vacancy-confirm__confirm">
                            <span>${ this.projectMessages.deleteProjectAsk }</span>
                            <button class="btn-std btn def-button" @click="$parent.$emit('check'); $emit('close');">${ this.projectMessages.deleteProject }</button>
                        </div>
                        </def-modal-alert>
                    `,
                    props: ['result', 'status'],
                },
                {
                    // text: response.text,
                    // status: response.status
                },
                {
                    adaptive: true,
                    width: 580,
                    height: 'auto',
                }, {
                    'closed': this.close,
                    'check': this.check,
                }
            );
        },
        addedUserProps() {
            this.$store.dispatch('project/changeProjectEmail', {
                "projectId": this.project_id,
                "firstTime": this.firstTime,
                "newProjectEmail": this.projectEmail
            });
            this.$store.dispatch('project/changeProjectPhone', {
                "projectId": this.project_id,
                "firstTime": this.firstTime,
                "newProjectPhone": this.projectPhone
            });
            this.$store.dispatch('project/changeProjectAddress', {
                "projectId": this.project_id,
                "firstTime": this.firstTime,
                "newProjectAddress": this.projectAddress
            });
        },
        close() {
            this.$emit('close');
        },
        check() {
            this.$emit('close');
            this.$store.dispatch('project/deleteProject', {
                projectId: this.project_id,
                link: this.link,
            });
        },
    },
}


</script>
<style lang="scss">
.modal-vacancy-confirm__confirm{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .def-button{
        margin-top: 20px;
        font-size: 14px;
    }
}
</style>
